import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=195152d0&scoped=true&"
import script from "./homeFooter.vue?vue&type=script&lang=js&"
export * from "./homeFooter.vue?vue&type=script&lang=js&"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=195152d0&lang=scss&scoped=true&"
import style1 from "./homeFooter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195152d0",
  null
  
)

export default component.exports